// extracted by mini-css-extract-plugin
export default {"containerbox":"BUGroupedData_containerbox__SPhZ4","paradigmGrid":"BUGroupedData_paradigmGrid__6loU8","paddingInput":"BUGroupedData_paddingInput__BGT09"};